import React, { useState, useEffect, useRef } from "react";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useMessageStore } from "./message-store-context";

const ChatBotHeader = ({ onClose }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { clearMessages } = useMessageStore();

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="chatbot-header">
      <div className="chatbot-title-container">
        <Icon name="leaf" color="white" className="chatbot-leaf-icon" />
        <span className="chatbot-title">Leafie</span>
      </div>
      <div className="chatbot-header-icons">
        <Icon
          name="ellipsis vertical"
          className="chatbot-menu-icon"
          onClick={handleMenuClick}
        />
        {menuOpen && (
          <div className="chatbot-menu" ref={menuRef}>
            <div
              className="chatbot-menu-item"
              onClick={() => {
                clearMessages();
                setMenuOpen(false);
              }}
            >
              <Icon name="trash" className="chatbot-trash-icon" />
              Clear Conversation
            </div>
          </div>
        )}
        <Icon name="close" className="chatbot-close-icon" onClick={onClose} />
      </div>
    </div>
  );
};

ChatBotHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ChatBotHeader;
